import AccountCreation, { Social } from "@/components/signup/account-creation";

export const LoggedOutJiraProductTourAccountCreation = () => (
    <AccountCreation
        Login={null}
        Social={<Social providers={{ google: "Google" }} />}
    />
);
